"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var filterActive = function filterActive(users) {
  return users.filter(function (user) {
    return user.status === 'active';
  });
};

var uniqueBySourceId = function uniqueBySourceId(users) {
  var mapProp = 'sourcedId';
  return users.filter(function (obj, pos, user) {
    return user.map(function (mapObj) {
      return mapObj[mapProp];
    }).indexOf(obj[mapProp]) === pos;
  });
};

var _default = function _default(jsonObject) {
  if (!('users' in jsonObject)) {
    throw new Error('AmpApi: users are needed to parse roster.');
  }

  var users = jsonObject.users;

  if (!Array.isArray(users)) {
    throw new Error('AmpApi: expected users to be an array.');
  }

  return uniqueBySourceId(filterActive(users));
};

exports["default"] = _default;